/* =====================================================
   SIMPLY MOTIVATED — Theme JavaScript
   ===================================================== */

'use strict';

// ---- Header scroll behavior ----
const header = document.querySelector('.site-header');
if (header) {
  const onScroll = () => {
    header.classList.toggle('scrolled', window.scrollY > 40);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

// ---- Mobile nav toggle ----
const navToggle = document.querySelector('.nav-toggle');
const navPrimary = document.querySelector('.nav-primary');
const body = document.body;

if (navToggle && navPrimary) {
  navToggle.addEventListener('click', () => {
    const isOpen = navPrimary.classList.toggle('open');
    navToggle.classList.toggle('open', isOpen);
    navToggle.setAttribute('aria-expanded', isOpen.toString());
    body.style.overflow = isOpen ? 'hidden' : '';
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!navToggle.contains(e.target) && !navPrimary.contains(e.target)) {
      navPrimary.classList.remove('open');
      navToggle.classList.remove('open');
      navToggle.setAttribute('aria-expanded', 'false');
      body.style.overflow = '';
    }
  });
}

// ---- Cart drawer ----
const cartOverlay = document.querySelector('.cart-overlay');
const cartDrawer = document.querySelector('.cart-drawer');
const cartBtns = document.querySelectorAll('[data-open-cart]');
const cartClose = document.querySelector('[data-close-cart]');

function openCart() {
  cartOverlay?.classList.add('open');
  cartDrawer?.classList.add('open');
  body.style.overflow = 'hidden';
  cartDrawer?.querySelector('[data-close-cart]')?.focus();
}

function closeCart() {
  cartOverlay?.classList.remove('open');
  cartDrawer?.classList.remove('open');
  body.style.overflow = '';
}

cartBtns.forEach(btn => btn.addEventListener('click', openCart));
cartClose?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);

// Escape key closes cart and nav
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCart();
    if (navPrimary?.classList.contains('open')) {
      navPrimary.classList.remove('open');
      navToggle?.classList.remove('open');
      body.style.overflow = '';
    }
  }
});

// ---- Scroll-reveal with IntersectionObserver ----
const animateEls = document.querySelectorAll('[data-animate]');
if (animateEls.length && typeof IntersectionObserver !== 'undefined') {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  animateEls.forEach((el) => observer.observe(el));
}

// ---- Size selector ----
const sizeBtns = document.querySelectorAll('.size-btn');
sizeBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.size-options');
    group?.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
  });
});

// ---- Add to cart feedback ----
const addToCartBtn = document.querySelector('.add-to-cart-btn');
if (addToCartBtn) {
  addToCartBtn.addEventListener('click', () => {
    const originalText = addToCartBtn.textContent;
    addToCartBtn.textContent = 'Added ✓';
    addToCartBtn.style.background = '#2a7a3a';
    setTimeout(() => {
      addToCartBtn.textContent = originalText;
      addToCartBtn.style.background = '';
      openCart();
    }, 1200);
  });
}

// ---- Product thumbnail gallery ----
const thumbs = document.querySelectorAll('.product-thumb');
const mainImg = document.querySelector('.product-main-image img');
thumbs.forEach((thumb) => {
  thumb.addEventListener('click', () => {
    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    if (mainImg) {
      const src = thumb.querySelector('img')?.src;
      if (src) mainImg.src = src;
    }
  });
});

// ---- Email form ----
const emailForm = document.querySelector('.email-form');
if (emailForm) {
  emailForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const input = emailForm.querySelector('input[type="email"]');
    const btn = emailForm.querySelector('button[type="submit"]');
    if (!input?.value) return;
    if (btn) {
      btn.textContent = 'You\'re in';
      btn.disabled = true;
      btn.style.background = '#2a7a3a';
    }
  });
}

// ---- Subtle parallax on hero ----
const heroBg = document.querySelector('.hero__bg img');
if (heroBg && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const maxScroll = window.innerHeight;
    if (scrollY <= maxScroll) {
      const translateY = (scrollY * 0.3).toFixed(1);
      heroBg.style.transform = `scale(1) translateY(${translateY}px)`;
    }
  }, { passive: true });
}

// ---- Announcement bar dismiss ----
const announceClose = document.querySelector('[data-dismiss-announce]');
const announceBar = document.querySelector('.announcement-bar');
if (announceClose && announceBar) {
  announceClose.addEventListener('click', () => {
    announceBar.style.height = announceBar.offsetHeight + 'px';
    requestAnimationFrame(() => {
      announceBar.style.transition = 'height 300ms ease-out, opacity 300ms ease-out';
      announceBar.style.height = '0';
      announceBar.style.overflow = 'hidden';
      announceBar.style.opacity = '0';
    });
  });
}
